import createTableStore from "ds/components/Table/store/useTableStore";

import { STACK_ROLES_COLUMN_CONFIG, STACK_ROLES_STORAGE_KEY } from "./constants";

const useStackRolesTableStore = createTableStore({
  storageKey: STACK_ROLES_STORAGE_KEY,
  config: STACK_ROLES_COLUMN_CONFIG,
});

export default useStackRolesTableStore;
